<template>
    <ul class="equipments-list">
        <equipment-list-item v-for="product in products" :key="product.identifier" v-if="product" :product="product" :item-style="listType" />
    </ul>
</template>

<script>
    import EquipmentListItem from "@/components/Equipment/EquipmentListItem.vue"

    export default {
        name: 'EquipmentList',
        components: {
            EquipmentListItem,
        },
        props: {
            products: {
                type: Array,
                default: () => []
            },
            listType: {
              type: String,
              required: false,
              default: 'block'
            }
        },
    }
</script>

<style lang="scss">
    .equipments-list {
        padding-left: 20px;
        list-style-type: disc;
    }
</style>